import { type SetCapabilitiesAction } from 'src/types';

import { CapabilitiesActions, CapabilitiesStateKeys } from '../constants/Capabilities';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [CapabilitiesStateKeys.IS_MOBILE]: false,
  [CapabilitiesStateKeys.IS_TABLET]: false,
});
export type CapabilitiesState = typeof INITIAL_STATE;

// BROWSEGENRES REDUCER
export default createReducer(INITIAL_STATE, {
  [CapabilitiesActions.SET_CAPABILITIES]: setCapabilities,
});

// CASE FUNCTIONS

function setCapabilities(
  state: CapabilitiesState,
  { payload: { isMobile, isTablet } }: SetCapabilitiesAction,
): CapabilitiesState {
  return state.merge({
    [CapabilitiesStateKeys.IS_MOBILE]: isMobile,
    [CapabilitiesStateKeys.IS_TABLET]: isTablet,
  });
}
